import Model, { attr, hasMany } from '@warp-drive/legacy/model';
import { Type } from '@warp-drive/core-types/symbols';
import type PcsMerchantNetworkMerchantModel from './pcs-merchant-network-merchant.ts';
import type PcsNetworkMerchantModel from './pcs-network-merchant.ts';

export default class PcsMerchantModel extends Model {
  @attr declare entityType: string;
  @attr declare entityId: number;
  @attr declare locationNames: string[];

  /*************************
   **  Relationships      **
   *************************/

  @hasMany('pcs-merchant-network-merchant', { async: false, inverse: 'pcsMerchant' })
  declare pcsMerchantNetworkMerchants: PcsMerchantNetworkMerchantModel[];

  @hasMany('pcs-network-merchant', { async: false, inverse: null })
  declare pcsNetworkMerchants: PcsNetworkMerchantModel[];

  [Type] = 'pcs-merchant' as const;
}
